import React, { useState, useEffect, useRef } from 'react';

// material ui
import Typography from '@material-ui/core/Typography';
import Grid from '@material-ui/core/Grid';
import FormControl from '@material-ui/core/FormControl';
import FormControlLabel from '@material-ui/core/FormControlLabel';
import FormHelperText from '@material-ui/core/FormHelperText';
import RadioGroup from '@material-ui/core/RadioGroup';
import Radio from '@material-ui/core/Radio';

import useStyles from './styles';

import Button from '@material-ui/core/Button';
import CircularProgress from '@material-ui/core/CircularProgress';
import ChevronRight from '@material-ui/icons/ChevronRight';
import ChevronLeft from '@material-ui/icons/ChevronLeft';
import InfoButton from '../../../../../components/InfoButton';


function SubForm06({ id, setValue, saveValue, saveValueJump, value, kb, handleNextSub, navigationMode, handleBackSub, no_kk, isSubmitting, setKB }) {

    const nextRef = useRef(null);
    const backRef = useRef(null);

    const classes = useStyles();
    const [error, setError] = useState({});
    const [useContrasep, setUseContrasep] = useState(false);

    const [jenisKontrasepsi, setJenisKontrasepsi] = useState(value.jenis_kontrasepsi || '')

    const pertanyaan = "Jenis alat/obat/cara kontrasepsi yang dipakai saat ini atau terakhir dipakai";

    useEffect(() => {

        let normalizeValue = {
            _id: `${no_kk}${id}`,
            Pertanyaan: pertanyaan,
            Jawaban_H1: 0,
            Jawaban_H2: 0,
            Jawaban_HDate1: "",
            Jawaban_HDate2: "",
            No_Pertanyaan: 6,
            No_KK: no_kk,
            answer: [
                {
                    _id: `${no_kk}${id}01`,
                    No_Jawaban: jenisKontrasepsi,
                    Jawaban_D1: 0,
                    Jawaban_D2: 0,
                    Jawab_D3: 0,
                    Jawab_D4: 0,
                    pilihankb: 0,
                    Lainnya: ""
                },

            ]

        }

        if (value._rev) {
            normalizeValue._rev = value._rev
        }

        saveValueJump(normalizeValue)

    }, [jenisKontrasepsi])

    useEffect(() => {
        setError({})

        // if (kb["0104"].menggunakan_kontrasepsi === "1" || kb["0105"].pernah_menggunakan_kontrasepsi === "1" || (kb["0103"].sedang_hamil === "1" && kb["0105"].pernah_menggunakan_kontrasepsi === "2") ) {

        //     setUseContrasep(true);
        // } else {
        //     if (navigationMode === 'back') {
        //         handleBackSub();
        //     } else {
        //         handleNextSub()
        //     }
        // }

        /* cek kondisi untuk semua form */
        if (kb["0102"].sedang_hamil === "2" && kb["0103"].menggunakan_kontrasepsi === "2" && kb["0104"].pernah_menggunakan_kontrasepsi === "1") {
            setUseContrasep(true);
        } else if (kb["0102"].sedang_hamil === "1" && kb["0104"].pernah_menggunakan_kontrasepsi === "2") {

            let normalizeValue = {}
            //console.log("id 7 => ", id)
            setKB({
                ...kb,
                [id]: {
                    ...kb[id],
                    ["jenis_kontrasepsi"]: undefined
                }
            })

            if (navigationMode === 'back') {
                handleBackSub();
            } else {
                handleNextSub()
                saveValueJump(normalizeValue)
            }
        } else {
            if (kb["0102"].sedang_hamil === "2" && kb["0103"].menggunakan_kontrasepsi === "2" && kb["0104"].pernah_menggunakan_kontrasepsi === "2") {

                let normalizeValue = {}
                //console.log("id 7 => ", id)
                setKB({
                    ...kb,
                    [id]: {
                        ...kb[id],
                        ["jenis_kontrasepsi"]: undefined
                    }
                })

                if (navigationMode === 'back') {
                    handleBackSub();
                } else {
                    handleNextSub()
                    saveValueJump(normalizeValue)
                }


            } else {
                setUseContrasep(true);
            }
        }
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [])

    if (!useContrasep) {
        return null
    }


    // const [useContrasep, setUseContrasep] = useState(false);
    // useEffect(() => {
    //     setError({})

    // if (kb["0104"].menggunakan_kontrasepsi === "1" || kb["0105"].pernah_menggunakan_kontrasepsi === "1") {
    //     setUseContrasep(true);
    // } else {
    //     if (navigationMode === 'back') {
    //         handleBackSub();
    //     } else {
    //         handleNextSub()
    //     }
    // }
    // eslint-disable-next-line react-hooks/exhaustive-deps
    // }, [])

    // if (!useContrasep) {
    //     return null
    // }

    const handleChange = (e) => {

        setValue(e)

        setError({
            ...error,
            [e.target.name]: ""
        })

        if (e.target.name == "jenis_kontrasepsi") {
            setJenisKontrasepsi(e.target.value)
        }

        // setSomethingChange(true)
    }

    const validate = () => {
        let newError = {};

        if (!value.jenis_kontrasepsi) {
            newError.jenis_kontrasepsi = "Wajib diisi";
        }

        return newError;
    }

    const handleSubmit = (e) => {
        e.preventDefault()
        const findErrors = validate();

        const errorValues = Object.values(findErrors);

        if (errorValues.length > 0 && errorValues.some(err => err !== '')) {
            setError(findErrors);
        } else {

            // const normalizeValue = {
            //     pertanyaan,
            //     jawaban_1: value.jenis_kontrasepsi

            // }

            let normalizeValue = {
                _id: `${no_kk}${id}`,
                Pertanyaan: pertanyaan,
                Jawaban_H1: 0,
                Jawaban_H2: 0,
                Jawaban_HDate1: "",
                Jawaban_HDate2: "",
                No_Pertanyaan: 6,
                No_KK: no_kk,
                answer: [
                    {
                        _id: `${no_kk}${id}01`,
                        No_Jawaban: value.jenis_kontrasepsi,
                        Jawaban_D1: 0,
                        Jawaban_D2: 0,
                        Jawab_D3: 0,
                        Jawab_D4: 0,
                        pilihankb: 0,
                        Lainnya: ""
                    },

                ]

            }

            if (value._rev) {
                normalizeValue._rev = value._rev
            }

            saveValue(normalizeValue)
        }
    }


    return (
    <>
    <form id={id} onSubmit={handleSubmit} noValidate>
        <div className={classes.card}>
            <div className={classes.cardHeader}>
                <Typography margin="normal" paragraph>
                    <span className={classes.badge}>06</span>Jenis alat/obat/cara kontrasepsi yang dipakai <strong>saat ini</strong> atau <strong>terakhir</strong> dipakai</Typography>
                <div style={{ position: "absolute", right: "0", top: "58px" }}>
                    <InfoButton
                        content={
                            "Jika menggunakan 2 jenis kontrasepsi, maka pilih salah satu yang paling efektif. Keefektifan kontrasepsi dari yang paling tinggi sampai ke yang paling rendah yaitu MOP, MOW, IUD, Implant, Suntik, Pil, Kondom dan Tradisional."+
                            "\nMetode Amenorea Laktasi (MAL) merupakan salah satu pilihan metode kontrasepsi modern pada ibu pasca-persalinan yang harus memenuhi kriteria sebagai berikut: "+
                            "\nUsia bayi kurang dari 6 bulan; "+
                            "\nBayi hanya diberi ASI saja atau ASI eksklusif: bayi hanya diberi ASI saja tanpa tambahan makanan/minuman tambahan termasuk air putih, kecuali obat dan vitamin dari petugas kesehatan campur air;"+
                            "\nTidak membiarkan periode panjang tanpa menyusui, baik siang atau malam (bayi menyusui langsung dari payudara atau campuran dengan ASI perah)"+
                            "\nIbu belum menstruasi."+
                            "\nPantang berkala/kalender adalah pasangan sengaja tidak berhubungan seksual pada harihari tertentu pada waktu wanita berkemungkinan besar untuk menjadi hamil."+
                            "\nSenggama terputus adalah pria mengeluarkan air maninya di luar vagina ketika berhubungan seksual."
                        }
                    />
                </div>
            </div>
            <div className={classes.cardBody}>
                <Grid container spacing={1}>
                    <Grid item xs={12} >
                        <FormControl error={error.jenis_kontrasepsi ? true : false} component="fieldset" fullWidth>
                            <RadioGroup value={value.jenis_kontrasepsi || ''}
                                onChange={handleChange}
                                aria-label="jenis_kontrasepsi" name="jenis_kontrasepsi"
                                className={classes.radioGroup}
                            >
                                <div className={classes.radioSection}>
                                    <FormControlLabel control={<Radio />}
                                        value="1"
                                        label="1. MOW/steril wanita" />
                                    <FormControlLabel control={<Radio />}
                                        value="2"
                                        label="2. MOP/steril pria" />
                                    <FormControlLabel control={<Radio />}
                                        value="3"
                                        label="3. IUD/spiral/AKDR" />
                                    <FormControlLabel control={<Radio />}
                                        value="4"
                                        label="4. Implan/susuk" />
                                    <FormControlLabel control={<Radio />}
                                        value="5"
                                        label="5. Suntik" />
                                </div>
                                <div className={classes.radioSection}>
                                    <FormControlLabel control={<Radio />}
                                        value="6"
                                        label="6. Pil" />
                                    <FormControlLabel control={<Radio />}
                                        value="7"
                                        label="7. Kondom" />
                                    <FormControlLabel control={<Radio />}
                                        value="8"
                                        label="8. MAL (Wanita menyusui bayi dengan kondisi umur bayi kurang dari 6 bulan, bayi hanya diberi ASI saja, dan ibu belum haid kembali)" />
                                    <FormControlLabel control={<Radio />}
                                        value="9"
                                        label="9. Tradisional (pantang berkala/kalender/senggama terputus/jamu/lainnya)" />
                                </div>
                            </RadioGroup>
                            <FormHelperText>{error.jenis_kontrasepsi}</FormHelperText>
                        </FormControl>
                    </Grid>



                </Grid>
            </div>
        </div>
    </form>

    <Grid item xs style={{marginTop:20}}>
        <Button
            ref={backRef}
            // disabled={!isSomethingChange || isSubmitting}
            onClick={handleBackSub}><ChevronLeft className={classes.iconLeft} /> Sebelumnya </Button>

        {isSubmitting && <CircularProgress size={14} />}
        <Button
            style={{float: 'right'}}
            ref={nextRef}
            form={id}
            disabled={isSubmitting}
            type="submit">Selanjutnya <ChevronRight className={classes.iconRight} /></Button>
    </Grid>
    </>
    )
}

export default SubForm06;